import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_TRUCKS',
  'CREATE_TRUCK',
  'UPDATE_TRUCK',
  'UPDATE_TRUCK_STATUS',
  'SYNC_UPDATE_TRUCK'
);
